import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import { Item, SuccessPopUp } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { getMacAuthentication } from '../constants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { connect } from 'react-redux'
import TableCellTooltip from '../../../common/TableCellTooltip'
import { focusElemnt, isEmpty, navigation1, removeDuplicatesFromArray } from '../../../common/helper'
import { getMacAuthenticationTableData, updateMacAssign } from '../../../../store/branchAndUserMaster/BUMAction'
import { updateAlertError } from '../../../../store/common/common_action'
import { getUserList } from '../../../../store/common/common_action'
import { getAllBranchName } from '../../../../store/branchAndUserMaster/BUMAction'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import moment from 'moment'
import { useTranslation } from '../../../../i18n/I18nProvider'
const MacAuthentication = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const macAuthentication = getMacAuthentication(translations)
    const { data, updateAlertError, getMacAuthenticationTableData, updateMacAssign, getAllBranchName, getUserList,loginData } = props
    const { branchAndUserMasterReducer, common } = data
    const { loginDetails, userList } = common
    const { MacAuthTableData } = branchAndUserMasterReducer
    const [tableData, setTableData] = useState([])
    const [macBranchName, setMacBranchName] = useState('')
    const [macUserName, setMacUserName] = useState('')
    const [branchList, setBranchList] = useState([])
    const [userListData, setUserListData] = useState([])
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [isSuccess, setIsSuccess] = useState(false)
    const [userReset, setUserReset] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const width = window.innerWidth - 40
    useEffect(() => {
        setTimeout(() => {
            focusElemnt('maBranchName')
        }, 0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getTableData = () => {
        if (macBranchName === '' || macUserName === '') {
            updateAlertError({ show: true, msg: bum.pleaseSelectTheFilters || 'Please Select The Filters', success: false, nextId: `maBranchName` })
        } else {
            const object = {
                CompanyID: loginData?.intCompanyID,
                BranchID: macBranchName?.id,
                UserID: macUserName?.id
            }
            getMacAuthenticationTableData(object)
        }
    }
    useEffect(() => {
        if (MacAuthTableData?.length > 0) {
            const data = [...MacAuthTableData]
            data.sort((a, b) => {
                if (a.IsActive === b.IsActive) {
                    return a.CityName.localeCompare(b.CityName)
                }
                return b.IsActive - a.IsActive
            })
            let newData = data?.map((val, i) => ({ ...val, isEdited: false }))
            setTableData(newData)
        } else {
            setTableData([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [MacAuthTableData])
    useEffect(() => {
        setfilteredData(tableData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            getBranchListData()
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    useEffect(() => {
        if (!isEmpty(loginData) && macBranchName !== '') {
            getUserListData()
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID, macBranchName])
    const getUserListData = () => {
        const object = {
            intUserID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: macBranchName?.id,
            strUserName: "",
            strLoginID: "",
            strPassword: "",
            strContactNo: "",
            intRoleID: 0,
            intIsActive: 1
        }
        getUserList(object, true, 24 * 60 * 60 * 1000)
    }

    const getBranchListData = () => {
        const object = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: "",
            strBranchCode: "",
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1
        }
        getAllBranchName(object,true,24*60*60*1000)?.then((res) => {
            if (res?.status === 'Success') {
                if (res?.Data?.Table?.length < 0) {
                    updateAlertError({ show: true, msg: bum.noDataForBranchList || 'No Data For Branch List', success: false, nextId: `maBranchName` })
                } else {
                    let branches = res?.Data?.Table?.map(obj => ({ name: obj.BranchName, id: obj.BranchID, city: obj.CityName }))
                    setBranchList(branches)
                    let filteredBranch = branches.filter(branch => branch.id === loginData?.intBranchID);
                    filteredBranch.length > 0 ? setMacBranchName(filteredBranch[0]) : setMacBranchName("")
                }
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    useEffect(() => {
        if (userList?.length > 0) {
            var users = []
            userList.map((obj) => (
                users.push({
                    id: obj.UserID,
                    name: obj.UserName,
                })
            ))
            users = removeDuplicatesFromArray(users, `id`)
            setUserListData(users)
            let filteredUser = users.filter(user => user.id === loginData?.intUserID);
            filteredUser.length > 0 ? setMacUserName(filteredUser[0]) : setMacUserName("")
        } else {
            setUserListData([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userList])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const object = {
                CompanyID: loginData?.intCompanyID,
                BranchID: loginData?.intBranchID,
                UserID: loginData?.intUserID
            }
            getMacAuthenticationTableData(object)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return macAuthentication.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues])
    const handleRowChkChange = (e, index, item) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].IsActive = e.target.checked ? 1 : 0
            newVal[index].isEdited = !newVal[index].isEdited
            setfilteredData(newVal)
        }

        setTimeout(() => {
            focusElemnt(`ma-chkbox-${index}`)
        }, 0)
    }
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const handleSave = () => {
        let object = {
            RequestIDs: '',
            UserIDs: '',
            BranchIDs: '',
            IsActives: '',
            ModifedByUser: loginData?.intUserID
        }
        filteredData?.map((val, i) => {
            if (val.isEdited) {
                object.UserIDs = object?.UserIDs === '' ? macUserName?.id : object?.UserIDs + '^' + macUserName?.id
                object.BranchIDs = object?.BranchIDs === '' ? macBranchName?.id : object?.BranchIDs + '^' + macBranchName?.id
                object.RequestIDs = object?.RequestIDs === '' ? val?.RequestID : object?.RequestIDs + '^' + val?.RequestID
                object.IsActives = object?.IsActives === '' ? val?.IsActive : object?.IsActives + '^' + val?.IsActive
            }
        })
        updateMacAssign(object)?.then((res) => {
            if (res?.status === 'Success') {
                setIsSuccess(true)
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const ShowMacAuthenticationConfirmation = () => {
        const data = {
            successMessage: bum.doYouWantToAssignMacToSelectedUserQ || 'Do you want to Assign Mac to Selected User?',
            otherMessage: '',
            buttonId1: '',
            buttonId2: '',
            headTxt: bum.macAuthentication || 'Mac Authentication',
            yesAction: () => { handleSave(); setShowConfirmation(false) },
            noAction: () => setShowConfirmation(false)
        }
        return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
    }
    const handleChkBoxNavigation = (e, nextId, prevId) => {
        if (e.key === 'ArrowUp') {
            focusElemnt(prevId)
        }
        if (e.key === 'ArrowDown') {
            focusElemnt(nextId)
            e.preventDefault()
        }
        if (e.key === 'Enter') {
            focusElemnt('maSaveBtn')
            e.preventDefault()
        }
    }
    const InsideRowContent = (item, index) => {
        const width = window.innerWidth - 40
        return (
            <TableRow key={`MA-${index}`}>
                <TableCell style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>{index + 1}</TableCell>
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macAuthentication.widthPercent) / 100)}px`}
                    title={item.CityName !== '' ? item.CityName : macBranchName?.city}
                    data={item.CityName !== '' ? item.CityName : macBranchName?.city}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macAuthentication.widthPercent) / 100)}px`}
                    title={item.BranchName !== '' ? item.BranchName : macBranchName?.name}
                    data={item.BranchName !== '' ? item.BranchName : macBranchName?.name}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macAuthentication.widthPercent) / 100)}px`}
                    title={item.guid}
                    data={item.guid}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macAuthentication.widthPercent) / 100)}px`}
                    title={item.locationcity}
                    data={item.locationcity}
                />
                <TableCell style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666', padding: '0px' }}>
                    <Checkbox id={`ma-chkbox-${index}`} checked={item.IsActive === 1} sx={{ height: '36px' }}
                        onChange={(e) => handleRowChkChange(e, index, item)}
                        onKeyDown={(e) => {
                            handleChkBoxNavigation(e, index < filteredData?.length - 1 ? `ma-chkbox-${index + 1}` : 'maSaveBtn', index === 0 ? 'maSaveBtn' : `ma-chkbox-${index - 1}`)
                        }}
                    />
                </TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>{item.ModifiedByUser}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>{item.ModifiedDate ? moment(item.ModifiedDate).format('HH:mm, DD-MMM-YY') : ''}</TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, paddingLeft: "0px", paddingTop: '16px', gap: '16px' }} className="reportButton">
                <Item sx={sx.itemsx}>
                    <DropDownOA id='maBranchName' label={bum.branchName || 'Branch Name'} minWidth="250px"
                        defaultvalue={macBranchName?.name || ''}
                        value={macBranchName?.name || ''}
                        data={branchList || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setMacBranchName(value)
                            setUserReset(false);
                            setTimeout(() => {
                                setUserReset(true)
                            }, 100);
                        }}
                        prevId='maSaveBtn'
                        nextId='maUserName'
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA id='maUserName' label={bum.selectUser || 'Select User'} minWidth="250px"
                        defaultvalue={macUserName?.name || ''}
                        value={macUserName?.name || ''}
                        data={userListData || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setMacUserName(value)
                        }}
                        prevId='maBranchName'
                        nextId='maLoadBtn'
                        resetFlag={userReset}

                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='maLoadBtn' variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={() => { getTableData() }}
                        onKeyDown={(e) => {
                            navigation1(e, 'maSaveBtn', 'maUserName');
                        }}
                    >
                        {bum.load || 'LOAD'}
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button tabIndex={0} id='maSaveBtn' variant="outlined" color="secondary" style={{ height: '40px' }}
                        onClick={() => setShowConfirmation(true)}
                        onKeyDown={(e) => {
                            navigation1(e, filteredData?.length > 0 ? 'ma-chkbox-0' : 'maBranchName', 'maLoadBtn');
                        }}
                    >
                        {bum.saveUpper || 'SAVE'}
                    </Button>
                </Item>
            </Box>
            <Box sx={{ margin: '16px 0px 0px 0px' }}>
                <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '60vh', marginBottom: '5px' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px',
                                color: '#444',
                                lineHeight: 1
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: '2', whiteSpace: 'pre' }}>
                            <TableRow>
                                {macAuthentication.map((col, index) => (
                                    <TableCell
                                        key={`TH-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            height: '36px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            width: col.fixedWidth
                                                ? `${col.fixedWidth}px`
                                                : `${Math.ceil((width * col.widthPercent) / 100)}px`,
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {macAuthentication.map((col, index) =>
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`} sx={col?.headerSx}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`index-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder={bum.contains || "Contains"}
                                                    onChange={(e) => handleChangeContain(e, col.field)}
                                                    onKeyDown={(e) => navigation1(e, index === 6 ? `index-1` : index === 4 ? `index-6` : `index-${index + 1}`, index === 1 ? `index-6` : index === 6 ? `index-4` : `index-${index - 1}`)}
                                                />
                                                <FilterAltIcon />
                                            </div>
                                        </TableCell>
                                    ) : (
                                        <TableCell key={`empty-cell-${index}`}></TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        {filteredData?.length <= 0 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell key={'empty-tbl-cell'} colSpan={14}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>{bum.noResultsFoundPleaseRefineYourSearchParametersAndSearchAgain || 'No results found. Please refine your search parameters and search again.'}</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : filteredData.length > 0 ? (
                            <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                                {filteredData?.map((item, index) => InsideRowContent(item, index))}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                </TableContainer>
            </Box>
            {showConfirmation && <ShowMacAuthenticationConfirmation />}
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); getTableData(); focusElemnt('maBranchName') }} open={isSuccess} title={bum.macAuthenticationStatusSavedSuccessfullyNl || 'Mac Authentication Status\n Saved Successfully'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getMacAuthenticationTableData, updateMacAssign, updateAlertError, getAllBranchName, getUserList }
export default connect(mapStateToProps, mapDispatchToProps)(MacAuthentication)
